import { G_BUTTON__use_selected_image_in_field } from './_buttons/G_BUTTON__use_selected_image_in_field';
import { G_DROPDOWN__image_select_category } from './G_DROPDOWN__image_select_category';
import { RADIO__image_select_context } from './RADIO__image_select_context';

export function G_SIDEBAR__IMAGE_EDIT__image_replace() {
  return (
    <div className="flex flex-col items-start gap-2 size-full p-2">
      <div className="text-sm text-bar-foreground">Actions</div>
      <G_BUTTON__use_selected_image_in_field />

      <G_DROPDOWN__image_select_category />
      <RADIO__image_select_context />
    </div>
  );
}
